import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import useContentId from './useContentId';
const SmartContentQuery = registerQuery({
  fieldName: 'smartContent',
  fetcher: ({
    pageId
  }) => {
    return http.get(`targeted/v1/definitions/by-content/${pageId}`).then(response => response.map(data => ({
      criteria: data.criteria.map(({
        id,
        name
      }) => ({
        id,
        name
      })),
      id: data.id,
      moduleName: data.moduleName,
      name: data.name
    })));
  }
});
const useSmartContent = () => {
  const pageId = useContentId();
  const {
    data,
    loading,
    error
  } = useQuery(SmartContentQuery, {
    variables: {
      pageId
    },
    skip: !pageId
  });
  const smartContentDefinitions = useMemo(() => (data === null || data === void 0 ? void 0 : data.smartContent) || [], [data]);
  const smartContentDefinitionsCount = useMemo(() => smartContentDefinitions.length, [smartContentDefinitions]);
  return useMemo(() => ({
    smartContentDefinitions,
    smartContentDefinitionsCount,
    smartContentRequestLoading: loading,
    smartContentRequestError: error
  }), [smartContentDefinitions, smartContentDefinitionsCount, error, loading]);
};
export default useSmartContent;